import { Alert, Box, Button, Container, Tab, Tabs, Typography } from "@mui/material";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import { useContext, useEffect, useState } from 'react';
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { MdBackspace } from "react-icons/md";
import IResearchService from "../../services/IResearchService";
import { Publication } from "../../interfaces/ProductosDTOS/Publication";
import DataTable from "../../componentes/Productos/DataTableImport";
import { getVoidProdcutoTerminadoDTO, ProductoTerminadoDTO } from "../../interfaces/ProductoTerminadoDTO";
import { GetProyectoEvntDTO } from "../../interfaces/ProyectosDTOS/EventoProyDTO";
import { EmailProductoCreado, setEmailProductoCreado } from "../../interfaces/MailModel";
import EventoService from "../../services/EventoService";
import EmailService from "../../services/EmailService";
import ProductoForm from "../../componentes/Productos/ProductoForm";
import ProductoService from "../../services/ProductoService";
import { setProductoTerminadoImport, TblProductoProdTermin } from "../../interfaces/TblProductoProdTermin";
import { GetProductoMotivoImportByDoiEid, TblDecInvMotivoProdTermin } from "../../interfaces/TblDecInvMotivoProdTermin";
import { getVoidProductoAreaConocimientoDTO, ProductoAreaConocimientoDTO } from "../../interfaces/ProductoAreaConocimientoDTO";
import { GetVoidAreaImplementacion, ProductoAreaImplementacion } from "../../interfaces/ProductoAreaImplementacionDTO";
import { getVoidProductoLineaInvestigacionDTO, ProductoLineaInvestigacionDTO } from "../../interfaces/ProductoLineaInvestigacionDTO";
import { getVoidProductoTerminadoObjOdDTO, ProductoTerminadoObjOdDTO } from "../../interfaces/ProductoTerminadoObjOdDTO";
import { ProductoColaboradorDTO } from "../../interfaces/ColaboradorProdcutoDTO";
import { ProductoTerminSolicitanteDTO } from "../../interfaces/ProductoTerminSolicitanteDTO";
import { ProductoObjEspecifico } from "../../interfaces/ProductoObjEspecificoDTO";
import { ProductoFactorImpacto, SetListProductoFactorImpacto } from "../../interfaces/ProductoFactorImpacto";
import { GetVoidProductoPostGrado } from "../../interfaces/ProductoPostGradoDTO";
import { getVoidProductoInstitucionPais } from "../../interfaces/ProductoInstitucionPaisDTO";
import AlertService from "../../services/AlertService";
import { GetVoidReviewEid, ReviewEid } from "../../interfaces/ProductosDTOS/ReviewEid";

const usuarioService = new UsuarioService();
const iresearch = new IResearchService();
const eventService = new EventoService();
const emailService = new EmailService();
const productoService = new ProductoService();
const alerta = new AlertService();

const cardHeaderStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};

export const ImportProductoPage: React.FC<{}> = () => {
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const userData = casUserContext.userData;
    let history = useNavigate();
    const [auth, setAuth] = useState(false);
    const [ready, setReady] = useState(false);
    const [importandoAp, setImportandoAp] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [idCategoria, setIdCategoria] = useState(0);
    const [datosFormulario, setDatosFormulario] = useState<ProductoTerminadoDTO>(() => getVoidProdcutoTerminadoDTO());
    const [doi, setDoi] = useState('');
    const [titulo, setTitulo] = useState('');
    const [publicaciones, setPublicaciones] = useState<Publication[]>([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };
    const goToNavigation = (site: string) => {
        history(site)
    }
    //Seccion Carga
    useEffect(() => {
        const flag = usuarioService.authorized(userData.roles);
        setAuth(flag);
    }, [userData]);

    //Seccion funcion
    const getPublicaciones = async () => {
        const scopusId = userData.scopusid;
        if (titulo.length > 0) {
            await iresearch.GetMyPublicationsByScopusId(scopusId, titulo)
                .then((data) => {
                    console.log(data.data)
                    if (data.status.isSuccessfully) {
                        setPublicaciones(data.data.data);
                        setPage(data.data.page);
                        setPageSize(data.data.pageSize);
                        setTotalCount(data.data.totalCount);
                        if(data.data.totalCount <= 0){
                            alerta.alertaAdvertencia('Alerta', 'No se encontraron registros que coincidan con la búsqueda.');
                        }
                    }
                }).catch((e) =>
                    console.error(e)
                )
        } else {
            alerta.alertaAdvertencia('Alerta', 'Debe escribir un título para buscar');
        }
    }

    function setProducto(data: any) {
        const idpersona = userData.idpersona;
        setDatosFormulario({
            ...datosFormulario,
            producto: setProductoTerminadoImport(data.data.producto) as TblProductoProdTermin,
            motivo: GetProductoMotivoImportByDoiEid(idpersona) as TblDecInvMotivoProdTermin,
            areaConocimiento: getVoidProductoAreaConocimientoDTO() as ProductoAreaConocimientoDTO,
            areaImplementacion: GetVoidAreaImplementacion() as ProductoAreaImplementacion,
            lineaInvestigacion: getVoidProductoLineaInvestigacionDTO() as ProductoLineaInvestigacionDTO,
            ods: getVoidProductoTerminadoObjOdDTO() as ProductoTerminadoObjOdDTO,
            colProducto: [] as Array<ProductoColaboradorDTO>,
            solicitantes: [] as Array<ProductoTerminSolicitanteDTO>,
            institucion: getVoidProductoInstitucionPais(),
            archivosProd: [],
            proyectorel: [],
            postgrados: GetVoidProductoPostGrado(),
            objEspecificos: [] as Array<ProductoObjEspecifico>,
            factorImpacto: SetListProductoFactorImpacto(data.data.factorImpacto) as Array<ProductoFactorImpacto>,
            resultados: [],
            idpersona: idpersona,
            idCategoriaProducto: data.data.idCategoriaProducto as number,
            eid: data.data.eid
        });
        setIdCategoria(data.idCategoriaProducto);
        setReady(true);
    }

    const handlePageChange = async (newPage: number, newPageSize: number) => {
        const scopusId = userData.scopusid;
        await iresearch.GetMyPublicationsByScopusId(scopusId, titulo, newPage, newPageSize)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    setPublicaciones(data.data.data);
                    setPage(data.data.page);
                    setPageSize(data.data.pageSize);
                    setTotalCount(data.data.totalCount);
                }
            }).catch((e) =>
                console.error(e)
            )
    };

    const handleSelectEid = async (eid: string) => {
        alerta.showLoading('Espere...');
        await productoService.GetPublicationScopusByEid(userData.token, eid)
            .then(data => {
                console.log(data.data)
                if (data.status.isSuccessfully) {
                    productoService.ReviewEid(userData.token, data.data)
                        .then(data2 => {
                            if (data.status.isSuccessfully) {
                                if (data2.data.check) {
                                    setProducto(data);
                                    setImportandoAp(true);
                                } else {
                                    alerta.alertaAdvertencia('Alerta', data2.data.mensaje);
                                }
                            } else {
                                alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema al validar la publicación.');
                            }
                        }).catch(e => {
                            alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema con el servicio de validación.');
                        })
                } else {
                    alerta.hideLoading();
                    alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema al importar la publicación.');
                }
            })
            .catch(e => {
                console.error(e)
                alerta.hideLoading();
                alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema con el servicio de importación.');
            });
    };

    const handleSelectDoi = async (doi: string) => {
        if (doi.length > 0) {
            alerta.showLoading('Espere...');
            productoService.GetPublicationScopusByDoi(userData.token, doi)
                .then(data => {
                    if (data.status.isSuccessfully) {
                        productoService.ReviewEid(userData.token, data.data)
                            .then(data2 => {
                                if (data.status.isSuccessfully) {
                                    if (data2.data.check) {
                                        setProducto(data);
                                        setImportandoAp(true);
                                    } else {
                                        alerta.alertaAdvertencia('Alerta', data2.data.mensaje);
                                    }
                                } else {
                                    alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema al validar la publicación.');
                                }
                            }).catch(e => {
                                alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema con el servicio de validación.');
                            })
                    } else {
                        alerta.hideLoading();
                        alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema al importar la publicación.');
                    }
                })
                .catch(e => {
                    console.error(e);
                    alerta.hideLoading();
                    alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema con el servicio de importación.');
                })
        } else {
            alerta.alertaAdvertencia('Alerta', 'Debe ingresar un Doi ejemplo: 10.1016/j.aaf.2024.06.003');
        }
    }

    const cancelSelectDoi = () => {
        setDatosFormulario(getVoidProdcutoTerminadoDTO);
        setImportandoAp(false);
    };

    const handleResponse = async (responseData: ProductoTerminadoDTO) => {
        // Manejar la respuesta aquí
        if (responseData.producto.iddecinvproyecto > 0) {
            var evnt = GetProyectoEvntDTO(responseData.producto.iddecinvproyecto, userData.idinv, responseData.producto.iddecinvtipoproductoesperado, "INGRESO DE", responseData.producto.titulo, "");
            const respE = await eventService.GuardarEventoProductoIngresado(evnt, userData.token);
        }
        var obt: EmailProductoCreado = setEmailProductoCreado("Ingreso de Producto", userData.emailAddress, responseData);
        const resp = await emailService.MailProductoCreado(obt, userData.token);
        goToNavigation('/Producto/MisProductos');
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Card>
                <CardHeader style={cardHeaderStyles}>
                    <strong>Importar Scopus</strong>
                    <Button variant="contained" aria-label="add" endIcon={<MdBackspace />} onClick={() => goToNavigation("/Producto/MisProductos")}>
                        Volver
                    </Button>
                </CardHeader>
                <CardBody></CardBody>
                <Container sx={{ mb: 2 }}>
                    {auth ?
                        <Box>
                            <Tabs value={tabIndex} onChange={handleChange} aria-label="Import options">
                                <Tab label="Importar por DOI" />
                                <Tab label="Buscar en Scopus" />
                            </Tabs>
                            <Box mt={2}>
                                {tabIndex === 0 && (
                                    <Box sx={{ width: '100%' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '8px',          // Espacio entre input y botón
                                                width: '100%'        // Que ocupe todo el ancho
                                            }}
                                        >
                                            <Typography>
                                                Ingrese el DOI para importar la publicación:
                                            </Typography>
                                            {importandoAp ?
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="error"
                                                    onClick={cancelSelectDoi}
                                                    sx={{ whiteSpace: 'nowrap' }} // Evita que el botón se haga muy ancho
                                                >
                                                    Cancelar
                                                </Button>
                                                : <></>
                                            }
                                        </div>
                                        {importandoAp ? <>
                                            <Alert severity="warning">
                                                Los campos pintados de color{' '}
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        display: 'inline-block',
                                                        width: 20,
                                                        height: 20,
                                                        backgroundColor: '#FFFF99',
                                                        border: '1px solid #ccc',
                                                        verticalAlign: 'middle',
                                                        ml: 1,
                                                    }}
                                                />{' '}deben ser revisados o completados manualmente.
                                            </Alert>
                                            <ProductoForm
                                                productoterminado={datosFormulario}
                                                defaultTipo={0}
                                                defaultCategoria={idCategoria}
                                                idProducto={'24'}
                                                tiposAvalible={[]}
                                                categoriasAvalible={[]}
                                                importScopus
                                                usoProyectosParticipo
                                                onResponse={handleResponse}
                                            />
                                        </> :
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '8px',          // Espacio entre input y botón
                                                    width: '100%'        // Que ocupe todo el ancho
                                                }}
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Ingrese Doi '10.1016/j.aaf.2024.06.003'"
                                                    className="p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700"
                                                    style={{ flex: 1 }}   // El input ocupa todo el espacio disponible
                                                    onChange={e => setDoi(e.target.value)}
                                                />
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => handleSelectDoi(doi)}
                                                    sx={{ whiteSpace: 'nowrap' }} // Evita que el botón se haga muy ancho
                                                >
                                                    Buscar
                                                </Button>
                                            </div>
                                        }
                                    </Box>
                                )}
                                {tabIndex === 1 && (
                                    <Box sx={{ width: '100%' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '8px',          // Espacio entre input y botón
                                                width: '100%'        // Que ocupe todo el ancho
                                            }}
                                        >
                                            <Typography>
                                                Realice una búsqueda en Scopus para importar publicaciones:
                                            </Typography>
                                            {importandoAp ?
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="error"
                                                    onClick={cancelSelectDoi}
                                                    sx={{ whiteSpace: 'nowrap' }} // Evita que el botón se haga muy ancho
                                                >
                                                    Cancelar
                                                </Button>
                                                : <></>
                                            }
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '8px',          // Espacio entre input y botón
                                                width: '100%'        // Que ocupe todo el ancho
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Ingrese titulo..."
                                                className="p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700"
                                                style={{ flex: 1 }}   // El input ocupa todo el espacio disponible
                                                onChange={e => setTitulo(e.target.value)}
                                            />
                                            <Button
                                                size="small"
                                                variant="contained"
                                                onClick={getPublicaciones}
                                                sx={{ whiteSpace: 'nowrap' }} // Evita que el botón se haga muy ancho
                                            >
                                                Buscar
                                            </Button>
                                        </div>
                                        <br />
                                        {importandoAp ? <>
                                            <Alert severity="warning">
                                                Los campos pintados de color{' '}
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        display: 'inline-block',
                                                        width: 20,
                                                        height: 20,
                                                        backgroundColor: '#FFFF99',
                                                        border: '1px solid #ccc',
                                                        verticalAlign: 'middle',
                                                        ml: 1,
                                                    }}
                                                />{' '}deben ser revisados o completados manualmente.
                                            </Alert>
                                            <ProductoForm
                                                productoterminado={datosFormulario}
                                                defaultTipo={0}
                                                defaultCategoria={idCategoria}
                                                idProducto={'24'}
                                                tiposAvalible={[]}
                                                categoriasAvalible={[]}
                                                importScopus
                                                usoProyectosParticipo
                                                onResponse={handleResponse}
                                            />
                                        </> :
                                            <>
                                                <DataTable
                                                    data={publicaciones}
                                                    page={page}
                                                    pageSize={pageSize}
                                                    totalCount={totalCount}
                                                    onPageChange={handlePageChange}
                                                    onSelectEid={handleSelectEid}
                                                />
                                            </>
                                        }
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        :
                        <UnauthorizedPage />
                    }
                </Container>
            </Card>
        </Container>
    );
}